import { useMutation } from "@tanstack/react-query";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";


import {
  GeneralResponse,
  IuserDetails,
} from "../../../interface/GeneralResponse";
import Api from "../../generalApi/Api";
import { useToast } from "../../../Services/ToastContext";
import { Methods } from "../../../Constants/ApiConstants";
import { EndPoints } from "../../../Constants/endpoints";
import { nextStep, setUserDetails } from "../../../redux/reducers/registrationSlice";

export interface SignupRequest {
  CountryId: number;
  PhoneNumber: string;
  FullName?: string;
}

const useCheckNumber = () => {
  const dispatch = useDispatch();
  const { showToast } = useToast();
  const navigate = useNavigate();

  const mutation = useMutation({
    mutationFn: async (data: SignupRequest): Promise<GeneralResponse> => {
      const response = await Api<SignupRequest, GeneralResponse<IuserDetails>>({
        method: Methods.POST,
        endpoint: EndPoints.CheckFromNumber,
        body: data,
      });

      if (!response.Status) {
        // Throw an error to trigger the onError handler
        throw new Error(response.ErrorMessage || "An error occurred");
      }

      return response;
    },

    onSuccess: (data) => {
      dispatch(
        setUserDetails({
        ...data?.Data
        }),
      );
      dispatch(nextStep());
      navigate("/verify-code-register");
    },

    onError: (error: any) => {
      showToast(error.message || "An error occurred", "error");
    },
  });

  return mutation;
};

export default useCheckNumber;
